
<template>
  <html>
    <head>
      
    </head> 
    <body>
      <navbar></navbar>

      <img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
      />
      <div class="title-page-l">
        <p>ชื่อร้านค้า</p>
        <h1>ชื่อหนักงาน : อริยะ</h1>
      </div>

      <div class="title-page-r">
        <img 
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        >
  
      </div>
  <div class="bt" style="margin: auto;
  padding: 10px;">

<a href="LH6giftCode"  type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30"> <img class="iconbuttom" style="    margin-left: -12px;
    width: 29px;
    height: 30px;"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        >กรองรหัสแลกสินค้า</a>
<a href="LH6giftCode" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-3" ><img class="iconbuttom" style="    margin-left: -12px;
    width: 29px;
    height: 30px;"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-qr-code.jpg">Scan QR Code</a>
</div>
    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";

.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 2px;
  position: absolute;
  overflow: visible;
  text-align: right;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 15px;
  color: #ffffff;
  font-family: Prompt SemiBold;

}
.title-page-l p {
 font-size: 22px;
    color: #ffffff;
    margin-bottom: -20px;
    top: 5px;
    text-align: left;
    margin-left: 72px;
    margin-top: 8px;
}
.title-page-r {
  display: table;
  
  top: 6px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  width: 85px;
  height: 31px;
}
.title-page-r img {
  color: #ffffff;
  display: block;
    width: 60px; 
    height: 60px;
    margin-left:19px;

}
h1 {
  font-size: 20px;
  margin-top: 12px;
  text-align: left;
  margin-left: 72px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
}
.mt-30 {
  margin-top: 23%;
}
.btn-block {
    display: block;
    width: 100%;
    height: 76px;
    padding: 22px;
}
</style>
